'use client';

import useModalRef from './modal';
import useDrawerRef from './drawer';
import useCommonRef from './common';
import { showRefModal, createRefComponent } from './methods';
import {
  getUrlListener,
  createUrlListener,
  mergeUrlListenerAdapter,
  resetUrlListenerAdapter,
  defaultBrowserUrlListenerAdapter,
} from './url';
import { isBrowser } from './env';
import {
  mergeRefComponentMount,
  resetRefComponentMountAdapter,
  defaultDomMountAdapter,
} from './core/refComponentMountRegistry';
import {
  mergeNativeAdapter,
  resetNativeAdapter,
  getNativeRuntimeAdapter,
  isNativeRuntimeAdapterRegistered,
  isNativeRefComponentMountSupported,
  isNativeRefComponentMountDisabled,
  isNativeUrlListenerSupported,
  isNativeUrlListenerDisabled,
} from './core/nativeRuntimeAdapter';
import createInTreeMountAdapter from './imperative/createInTreeMountAdapter';

export * from './common';
export type {
  UrlListener,
  UrlListenerOptions,
  UrlListenerAdapter,
} from './url';
export type {
  CreateRefComponentOptions,
  RefComponentMountAdapter,
  RefComponentMountParams,
  RefComponentMountResult,
} from './types/refComponentMount';
export type {
  MergeNativeRuntimeAdapterInput,
  NativeRuntimeAdapterState,
} from './types/nativeRuntimeAdapter';
export type { InTreeMountAdapter } from './imperative/createInTreeMountAdapter';

export {
  useDrawerRef,
  useCommonRef,
  showRefModal,
  createRefComponent,
  getUrlListener,
  createUrlListener,
  isBrowser,
  mergeNativeAdapter,
  resetNativeAdapter,
  getNativeRuntimeAdapter,
  isNativeRuntimeAdapterRegistered,
  isNativeRefComponentMountSupported,
  isNativeRefComponentMountDisabled,
  isNativeUrlListenerSupported,
  isNativeUrlListenerDisabled,
  mergeRefComponentMount,
  resetRefComponentMountAdapter,
  defaultDomMountAdapter,
  createInTreeMountAdapter,
  mergeUrlListenerAdapter,
  resetUrlListenerAdapter,
  defaultBrowserUrlListenerAdapter,
};

export default useModalRef;
